import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/.eu';
import Kr from '@di-shared/features/history/.kr';
import Na from '@di-shared/features/history/.na';
import {HistoryTab} from '@di-shared/pages/[vin]/history';

export interface HistoryProps {
  vin: string;
  tab: string;
  month: string;
  date: string | null;

  changeTab(tabType: HistoryTab): void;

  changeMonth(date: Date): void;

  changeDate(date: Date | null): void;
}

export default function History({vin, tab, changeTab, month, changeMonth, date, changeDate}: HistoryProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          tab={tab}
          changeTab={changeTab}
          month={month}
          changeMonth={changeMonth}
          date={date}
          changeDate={changeDate}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          tab={tab}
          changeTab={changeTab}
          month={month}
          changeMonth={changeMonth}
          date={date}
          changeDate={changeDate}
        />
      </Environment.Kr>
      <Environment.Na>
        <Na
          vin={vin}
          tab={tab}
          changeTab={changeTab}
          month={month}
          changeMonth={changeMonth}
          date={date}
          changeDate={changeDate}
        />
      </Environment.Na>
    </>
  );
}
